import {useDispatch, useSelector} from "react-redux";
import {hrDialogsSelector, setRequestErrorAction} from "../../../store/slice";


export const useRequestError = () => {
    const dispatch = useDispatch();
    const {requestError: {message, title}} = useSelector(hrDialogsSelector);
    
    const handleClose = () => {
        dispatch(setRequestErrorAction({clear: true}));
    }

    return {
        isOpen: !!message.length,
        title,
        message,
        handleClose,
    }
}
